import autocomplete from 'autocompleter'

export default class extends HTMLElement {
  connectedCallback () {
    if (this.dataset.enabled === 'false') return

    this.autocompleter = autocomplete({
      input: this.input,
      preventSubmit: this.dataset.submitOnSelect === 'true' ? 0 : 1,
      minLength: 0,
      showOnFocus: true,
      onSelect: this.onSelect,
      render: this.render,
      fetch: this.fetch
    })
  }

  disconnectedCallback () {
    this.autocompleter?.destroy?.()
  }

  onSelect = (item) => {
    this.input.value = this.dataset.parentName ? item.name : item.full_name

    // In the "browse all folders" picker, re-open the dropdown after choosing a
    // folder that has subfolders so the user can keep drilling into deeper levels.
    if (this.dataset.allFolders === 'true' && item.has_children) {
      setTimeout(() => {
        this.input.focus()
        this.autocompleter?.fetch?.()
      }, 0)
    }
  }

  fetch = (text, resolve) => {
    const queryParams = new URLSearchParams({ q: text })

    if (this.dataset.parentFolderId) {
      queryParams.append('parent_folder_id', this.dataset.parentFolderId)
    } else if (this.dataset.parentName) {
      queryParams.append('parent_name', this.dataset.parentName)
    }

    if (this.dataset.allFolders === 'true') {
      queryParams.append('all_folders', 'true')
    }

    if (this.dataset.excludeFolderId) {
      queryParams.append('exclude_folder_id', this.dataset.excludeFolderId)
    }

    if (this.dataset.excludeDefault === 'true') {
      queryParams.append('exclude_default', 'true')
    }

    fetch('/template_folders_autocomplete?' + queryParams).then(async (resp) => {
      const items = await resp.json()

      resolve(items)
    }).catch(() => {
      resolve([])
    })
  }

  render = (item) => {
    const div = document.createElement('div')

    div.setAttribute('dir', 'auto')

    const label = this.dataset.parentName ? item.name : item.full_name

    // Show the folder hierarchy (muted parent path + emphasised leaf) so nested
    // folders sharing the same name stay distinguishable.
    if (!this.dataset.parentName && label && label.includes(' / ')) {
      const parts = label.split(' / ')
      const leaf = parts.pop()

      const parent = document.createElement('span')
      parent.className = 'opacity-50'
      parent.textContent = `${parts.join(' / ')} / `

      const leafEl = document.createElement('span')
      leafEl.className = 'font-medium'
      leafEl.textContent = leaf

      div.appendChild(parent)
      div.appendChild(leafEl)
    } else {
      div.textContent = label
    }

    // Hint that a folder can be expanded into deeper subfolders.
    if (this.dataset.allFolders === 'true' && item.has_children) {
      div.style.display = 'flex'
      div.style.justifyContent = 'space-between'
      div.style.alignItems = 'center'

      const chevron = document.createElement('span')
      chevron.className = 'opacity-40 ml-2'
      chevron.textContent = '›'

      div.appendChild(chevron)
    }

    return div
  }

  get input () {
    return this.querySelector('input')
  }
}
